import React, { createContext, FunctionComponent, useContext, useEffect, useState } from 'react';
import { getUsageChargeFilters } from './getUsageChargeFilters';
import { UsageChargeFilter } from 'api/openapi/telemetry';
import { useFeature } from 'featurehub-react-sdk';

const UsageChargeFiltersContext = createContext<UsageChargeFilter[]>([]);

UsageChargeFiltersContext.displayName = 'UsageChargeFiltersContext';

interface UsageChargeFiltersContextProviderProps {
  children?: React.ReactNode;
}

const UsageChargeFiltersContextProvider: FunctionComponent<
  UsageChargeFiltersContextProviderProps
> = ({ children }) => {
  const fbau1079AddUsageChargeFilterToVolumeBasedCharges = useFeature(
    'fbau-1079-add-usage-charge-filter-to-volume-based-charges'
  )!; // created 2023-03-08T18:43:52.634Z - all envs same
  const [usageChargeFilters, setUsageChargeFilters] = useState<UsageChargeFilter[]>([]);

  useEffect(() => {
    if (fbau1079AddUsageChargeFilterToVolumeBasedCharges) {
      // note: the usage charge filters API supports pagination.
      // there is a limit of 100 hard coded for now as we want
      // to retrieve all of the usage charge filters in one request.
      getUsageChargeFilters()
        .then((data) => {
          if (data.items) {
            setUsageChargeFilters(data.items);
          }
        })
        .catch((error) => {
          console.error(new Error(`Error while fetching usage charge filters: ${error}`));
        });
    }
  }, []);

  return (
    <UsageChargeFiltersContext.Provider value={usageChargeFilters}>
      {children}
    </UsageChargeFiltersContext.Provider>
  );
};

const useUsageChargeFilters = () => {
  const context = useContext<UsageChargeFilter[]>(UsageChargeFiltersContext);

  if (context === undefined) {
    throw Error('usage charge filters context must be used with usage charge filters provider');
  }

  return context;
};

export { UsageChargeFiltersContextProvider, useUsageChargeFilters };
